import { TicketService } from './../ticket.service';
import { Component, OnInit, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITicket } from '../ticket';
import { TransPipe } from '../../shared/trans.pipe';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit, AfterViewInit {
  sub: any;
  tickets: ITicket[] = [];
  en = false;
  ids: number[] = [];
  @ViewChildren('ngForTickets') ngForTickets: QueryList<any>;
  constructor(
    private route: ActivatedRoute,
    private ticketService: TicketService
  ) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.ids = params.ids.split(',');
      const lang = params.lang;
      lang === 'en' ? (this.en = true) : (this.en = false);
      this.ids.forEach(id => {
        this.getTickets(id);
      });
    });
  }

  ngAfterViewInit() {
    this.ngForTickets.changes.subscribe(q => {
      console.log(q.length, this.ids.length);
      if (q.length === this.ids.length) {
        setTimeout(() => {
          window.print();
        }, 400);
      }
    });
  }

  getTickets(id) {
    this.ticketService.getTicket(id).subscribe(res => {
      this.tickets.push(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/tickets/print/print.component.ts